function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M328.95 402.192C239.571 539.159 190.297 648.964 46.453 592.104c-143.844-56.86-214.293-219.73-157.351-363.78 56.942-144.05 299.119-130.73 442.963-73.87 143.844 56.86 81.53 118.025-3.115 247.738z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6A7595",
  fillOpacity: 0.26,
  d: "M-23 327h322v86.463L127 516-64 397l41-70z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#7E8CB3",
  fillRule: "evenodd",
  d: "M136.782 448.735c0 8.254-8.516 14.948-19.01 14.948-10.495 0-19.002-6.694-19.002-14.948 0-8.264 8.507-14.958 19.002-14.958 10.494 0 19.01 6.694 19.01 14.958zM7.073 373.192c0 8.263-8.507 14.957-19.002 14.957s-19-6.694-19-14.957c0-8.254 8.505-14.948 19-14.948s19.002 6.694 19.002 14.948z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M229.665 309.903h6.887V83.729h-6.887v226.174z",
  clipRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M204.892 299.13h24.773V56.836h-24.773V299.13zM314.158 341.426L137.579 443.155v20.653l176.579-101.873v-20.509z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M137.579 443.155L-39 341.426v20.47l176.579 101.912v-20.653z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M-39 341.426l176.579 101.951 176.578-101.951-176.52-101.941L-39 341.426z",
  clipRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M264.059 59.181v49.92l-92.785-53.553V5.638l92.785 53.543z",
  clipRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M240.412 54.26v32.792L178.19 51.208v-32.86l62.222 35.912z",
  clipRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M274.001 53.553l-9.942 5.628v49.92l9.942-5.726V53.553z",
  clipRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M247.134 84.02v6.946l12.473 7.14v-6.879l-12.473-7.208zM247.134 71.174v6.956l12.473 7.13v-6.888l-12.473-7.198zM247.134 58.232v6.946l12.473 7.14v-6.879l-12.473-7.207z",
  clipRule: "evenodd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M171.274 5.638L181.187 0l92.814 53.553-9.942 5.628-92.785-53.543z",
  clipRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M182.816 25.43v7.527l51.252 29.605v-7.556L182.816 25.43z",
  clipRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M137.618 407.505l-.039-136.197 108.954-62.92v136.051l-108.915 63.066z",
  clipRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M137.618 407.505l-.039-136.197-108.963-62.92v136.051l109.002 63.066z",
  clipRule: "evenodd"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M28.616 208.388l108.963 62.92 108.954-62.92-108.915-62.891-109.002 62.891z",
  clipRule: "evenodd"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M206.028 271.395l-24.297 14.086v-39.748l24.297-14.095v39.757z",
  clipRule: "evenodd"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M206.028 231.638L97.219 168.805l-24.345 14.056 108.856 62.93 24.298-14.153z",
  clipRule: "evenodd"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M152.011 388.013v-6.994l36.577-21.196v7.11l-36.577 21.08zM152.011 375.497v-6.994l36.577-21.196v7.11l-36.577 21.08zM221.43 324.502v24.297l17.488-10.124v-24.296l-17.488 10.123zM52.583 321.954v25.314l-17.489-10.095V311.86l17.489 10.094zM76.453 335.788v25.313l-17.488-10.104v-25.303l17.488 10.094z",
  clipRule: "evenodd"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M71.05 247.961v36.377l-35.956-20.741v-36.425l35.956 20.789z",
  clipRule: "evenodd"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M66.637 255.401v-5.919l-28.284-16.294v5.832l28.284 16.381z",
  clipRule: "evenodd"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  width: 481,
  height: 307,
  x: -123,
  y: 268,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 29.5
})));

function SvgLibraImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 440,
    height: 673,
    fill: "none",
    viewBox: "0 0 440 673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraImg);
export default __webpack_public_path__ + "static/media/libra_img.f1882cd2.svg";
export { ForwardRef as ReactComponent };